import { StyleSheet } from "react-native";
import Metrics from "../../../../Theme/Metrics";


export const tvChannelCardStyles = StyleSheet.create({
    title: {
        marginTop: Metrics.verticalScale(11),
        marginBottom: Metrics.verticalScale(5)
    }
})